import type { AnimationDirection } from "./types";

export class Animator {
  static animateElement(
    element: Element,
    animationType: string,
    delay: number = 0,
  ): void {
    const customDelay = parseInt(
      element.getAttribute("data-animate-delay") || "0",
    );
    let totalDelay = delay + customDelay;

    // Only apply delay if element is NOT already visible
    const rect = element.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    if (isVisible) {
      totalDelay = 0;
    }

    setTimeout(() => {
      element.classList.remove("animate-initial");
      element.classList.add("animate-active", `animate-${animationType}`);
    }, totalDelay);
  }

  static prepareElement(element: Element): void {
    element.classList.add("animate-initial");

    const duration = element.getAttribute("data-animate-duration");
    if (duration) {
      (element as HTMLElement).style.setProperty(
        "--animation-duration",
        `${duration}ms`,
      );
    }
  }

  static getOrderedChildren(
    children: Element[],
    direction: AnimationDirection,
  ): Element[] {
    const childArray = Array.from(children);

    switch (direction) {
      case "bottom":
        return childArray.reverse();
      case "right":
        return childArray.sort(
          (a, b) =>
            b.getBoundingClientRect().left - a.getBoundingClientRect().left,
        );
      case "left":
        return childArray.sort(
          (a, b) =>
            a.getBoundingClientRect().left - b.getBoundingClientRect().left,
        );
      default:
        return childArray;
    }
  }

  static getVisibleChildren(children: NodeListOf<Element>): Element[] {
    return Array.from(children).filter((child) => {
      const rect = child.getBoundingClientRect();
      return rect.bottom >= 0 && rect.top <= window.innerHeight;
    });
  }
}

